<template>
  <f7-page>
    <f7-navbar title="報表查詢" back-link="back"></f7-navbar>
    <f7-list no-hairlines-md>
      <f7-list-item>
        <f7-label>查詢範圍</f7-label>
        <f7-input type="text" placeholder="選擇日期" readonly="readonly" input-id="demo-calendar-modal" :value="value" clear-button />
      </f7-list-item>
      <f7-list-item title="報表單位" group-title />
      <f7-list-item radio title="營業時段" value="businessHours" name="unit" :checked="searchUnit === 'businessHours'" @change="setSearchUnit($event.target.value)" />
      <f7-list-item radio title="日" value="day" name="unit" :checked="searchUnit === 'day'" @change="setSearchUnit($event.target.value)" />
      <f7-list-item radio title="週" value="week" name="unit" :checked="searchUnit === 'week'" @change="setSearchUnit($event.target.value)" />
      <f7-list-item radio title="月" value="month" name="unit" :checked="searchUnit === 'month'" @change="setSearchUnit($event.target.value)" />
      <f7-list-item radio title="年" value="year" name="unit" :checked="searchUnit === 'year'" @change="setSearchUnit($event.target.value)" />
      <f7-button raised fill style="margin: 20px;" :style="{ background: startDate && endDate ? '#4CAF50' : '#888888' }" @click="search">查詢</f7-button>
    </f7-list>
  </f7-page>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import moment from 'moment'

export default {
  dependencies: ['themeColor'],
  mounted () {
    const that = this
    const today = moment().format('YYYY-MM-DD')
    this.setSearchRange({ startDate: today, endDate: today })
    this.$f7.calendar.create({
      inputEl: '#demo-calendar-modal',
      openIn: 'customModal',
      rangePicker: true,
      header: true,
      footer: true,
      dateFormat: 'yyyy-mm-dd',
      dayNamesShort: ['日', '一', '二', '三', '四', '五', '六'],
      monthNames: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
      monthNamesShort: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
      on: {
        change (c, [startDate, endDate]) {
          if (endDate) {
            that.setSearchRange({
              startDate: moment(new Date(startDate).toISOString()).format('YYYY-MM-DD'),
              endDate: moment(new Date(endDate).toISOString()).format('YYYY-MM-DD')
            })
          }
        }
      }
    })
  },
  computed: {
    ...mapState('statisticsModule', ['searchUnit', 'startDate', 'endDate']),
    ...mapGetters(['storeId']),
    value () {
      return this.startDate + ' - ' + this.endDate
    }
  },
  methods: {
    ...mapActions('statisticsModule', ['getCustomStatistics', 'setSearchUnit', 'setSearchRange']),
    search () {
      this.getCustomStatistics()
      this.$f7router.navigate(`/stores/${this.storeId}/statistics-search-results`)
    }
  }
}
</script>
